
import React, { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';
import BrandLogo from './navbar/BrandLogo';
import DesktopNav from './navbar/DesktopNav';
import MobileNav from './navbar/MobileNav';
import { useAuth } from '@/contexts/auth';
import { NAV_LINKS } from './navbar/constants';

const NavBar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMobile = useIsMobile();
  const { user } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Filter nav links based on authentication status
  // Only show navigation links if the user is authenticated
  const filteredNavLinks = user ? NAV_LINKS : [];

  return (
    <header 
      className={cn(
        'fixed top-0 left-0 right-0 z-50 transition-all duration-300',
        scrolled ? 'py-2' : 'py-3',
        'bg-navteal glass-nav'
      )}
      style={{ WebkitTapHighlightColor: 'transparent' }}
    >
      <div className="container mx-auto px-4 flex items-center justify-between h-16">
        <BrandLogo />

        {!isMobile && <DesktopNav navLinks={filteredNavLinks} />}

        {isMobile && (
          <MobileNav 
            navLinks={filteredNavLinks}
            mobileMenuOpen={mobileMenuOpen}
            toggleMobileMenu={toggleMobileMenu}
          />
        )}
      </div>
    </header>
  );
};

export default NavBar;
